const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "The text of prompt 1", answers: [], image: null },
      { id: "q2", question: "The text of prompt 2", answers: [], image: null },
      { id: "q3", question: "The text of prompt 3", answers: [], image: null },
      { id: "q4", question: "The text of prompt 4", answers: [], image: null },
      { id: "q5", question: "The text of prompt 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "english",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Welcome
  
  Say "Hello" to begin.`,
  voice: "",
  versionQuestion: "How many prompts would you like in this template?",
};

export default openEnded;
